import axios from "axios";
import { AttributeType } from "types";

type Props = {
  uploadedAttributes: AttributeType[];
  type: "make" | "generate";
  setUploadProgress: (progress: number) => void;
  formData: FormData;
};

export default async function postGeneratePreview({
  uploadedAttributes,
  type,
  setUploadProgress,
  formData,
}: Props) {
  return await axios({
    method: "POST",
    // httpsAgent,
    url: `https://hassei-ki-backend.onrender.com/api/${type}`,
    data: formData,
    responseType: "blob",
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      setUploadProgress(progressEvent.loaded / progressEvent.total);
    },
  });
}
